import styled from 'styled-components'

const Button = styled.button`
  background-color: brown;
  border-radius: 5px;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  padding: 5px 15px;
  text-transform: capitalize;
  align-items: center;
`

export default Button



// WEBPACK FOOTER //
// ./src/UI/Button/Button.js